import React from 'react';
import { Search, Users, AlertCircle } from 'lucide-react';
import ThemedCard from '../../themed/ThemedCard';
import { Guest } from '../types';

interface UnassignedGuestListProps {
  filteredGuests: Guest[];
  allGuestsCount: number;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  onDragStart: (guest: Guest) => void;
  onDragOver: (e: React.DragEvent) => void;
  onDropToGuestArea: () => void;
}

export const UnassignedGuestList: React.FC<UnassignedGuestListProps> = ({
  filteredGuests,
  allGuestsCount,
  searchQuery,
  setSearchQuery,
  onDragStart,
  onDragOver,
  onDropToGuestArea,
}) => {
  return (
    <ThemedCard className="p-4 sticky top-4 max-h-[calc(100vh-2rem)] overflow-auto">
      <div className="mb-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-wedding-text-body h-4 w-4" />
          <input
            type="text"
            placeholder="搜尋賓客..."
            className="w-full pl-10 pr-4 py-2 border border-wedding-pink/30 rounded-md"
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
          />
        </div>
      </div>
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-medium text-wedding-text-title">未安排座位賓客</h3>
        <div className="flex items-center space-x-1 text-sm text-wedding-text-body">
          <Users className="h-4 w-4" />
          <span>
            {filteredGuests.length} 組 ({filteredGuests.reduce((sum, guest) => sum + (guest.guestCount || 1), 0)} 人)
          </span>
        </div>
      </div>
      {filteredGuests.length > 0 ? (
        <div className="space-y-2" onDragOver={onDragOver} onDrop={onDropToGuestArea}>
          {filteredGuests.map((guest, index) => (
            <div
              key={guest.id || `filtered-guest-${index}`}
              draggable
              onDragStart={() => onDragStart(guest)}
              className="bg-wedding-pink/10 p-2 rounded cursor-move hover:bg-wedding-pink/20"
            >
              <p className="font-medium text-sm text-wedding-text-title">{guest.name}</p>
              <p className="text-xs text-wedding-text-body">{guest.group}</p>
              {guest.guestCount && guest.guestCount > 1 && (
                <p className="text-xs text-wedding-pink">共 {guest.guestCount} 人</p>
              )}
              {guest.dietaryRestrictions && (
                <p className="text-xs text-wedding-gold">{guest.dietaryRestrictions}</p>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div
          className="flex flex-col items-center justify-center py-8 text-center"
          onDragOver={onDragOver}
          onDrop={onDropToGuestArea}
        >
          <AlertCircle className="h-8 w-8 text-wedding-text-body mb-2" />
          <p className="text-wedding-text-body">
            {allGuestsCount === 0 ? '尚無確認出席的賓客' : '所有賓客都已安排座位'}
          </p>
          <p className="text-xs text-wedding-text-body mt-2">
            將賓客拖拉至此處可取消座位分配
          </p>
        </div>
      )}
    </ThemedCard>
  );
};
